function initTeamSwiper() {
	const teamSwiper = document.querySelector("#teamSwiper");
	if (!teamSwiper || typeof Swiper === "undefined") {
		return;
	}

	const pagination = teamSwiper.querySelector(".team__pagination");
	const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

	new Swiper(teamSwiper, {
		slidesPerView: 1.08,
		spaceBetween: 20,
		speed: reducedMotion ? 0 : 500,
		grabCursor: true,
		watchOverflow: false,
		pagination: {
			el: pagination,
			clickable: true,
		},
		breakpoints: {
			580: {
				slidesPerView: 2,
				spaceBetween: 20,
			},
			980: {
				slidesPerView: 3,
				spaceBetween: 20,
			},
			1366: {
				slidesPerView: 4,
				spaceBetween: 20,
			},
			1520: {
				slidesPerView: 4,
				spaceBetween: 36,
			},
		},
	});
}

function initArticlesSwiper() {
	const articlesSwiper = document.querySelector("#articlesSwiper");
	if (!articlesSwiper || typeof Swiper === "undefined") {
		return;
	}

	const previousButton = document.querySelector(".boxArticles__prev");
	const nextButton = document.querySelector(".boxArticles__next");
	const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

	new Swiper(articlesSwiper, {
		slidesPerView: 1.1,
		spaceBetween: 16,
		speed: reducedMotion ? 0 : 500,
		grabCursor: true,
		watchOverflow: false,
		navigation: {
			nextEl: nextButton,
			prevEl: previousButton,
		},
		breakpoints: {
			580: {
				slidesPerView: 2,
				spaceBetween: 24,
			},
			980: {
				slidesPerView: 3,
				spaceBetween: 28,
			},
			1280: {
				slidesPerView: 4,
				spaceBetween: 32,
			},
			1520: {
				slidesPerView: 4,
				spaceBetween: 48,
			},
		},
	});
}
